var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11822",
    "data-name": "Group 11822",
    transform: "translate(-4812 -2595)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 35,
    height: 35,
    transform: "translate(4812 2595)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11830",
    "data-name": "Group 11830",
    transform: "translate(4815.582 2599.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11829",
    "data-name": "Group 11829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M13.919,0A13.919,13.919,0,1,0,27.837,13.919,13.919,13.919,0,0,0,13.919,0Zm0,26.1A12.179,12.179,0,1,1,26.1,13.919,12.179,12.179,0,0,1,13.919,26.1Z",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_839",
    "data-name": "Ellipse 839",
    cx: 12.396,
    cy: 12.396,
    r: 12.396,
    transform: "translate(1.522 1.522)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_828",
    "data-name": "Ellipse 828",
    cx: 2.063,
    cy: 2.063,
    r: 2.063,
    transform: "translate(18.212 11.856)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_829",
    "data-name": "Ellipse 829",
    cx: 2.063,
    cy: 2.063,
    r: 2.063,
    transform: "translate(11.856 11.856)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_830",
    "data-name": "Ellipse 830",
    cx: 2.063,
    cy: 2.063,
    r: 2.063,
    transform: "translate(5.5 11.856)",
    fill: "#65676a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.ee0f913f3ce1e1c3addc39ec4e281ab9.svg";
export { ForwardRef as ReactComponent };